import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import { downloadSitemap } from '../../../utils/generateSitemap';

const QuickActions = ({ onFilterChange, currentFilter, onBulkAction, onNotification }) => {
  const navigate = useNavigate();

  const filterOptions = [
    { value: 'all', label: 'All Newsletters' },
    { value: 'published', label: 'Published' },
    { value: 'draft', label: 'Drafts' },
    { value: 'scheduled', label: 'Scheduled' }
  ];

  const bulkActionOptions = [
    { value: '', label: 'Bulk Actions' },
    { value: 'publish', label: 'Publish Selected' },
    { value: 'delete', label: 'Delete Selected' },
    { value: 'export', label: 'Export Selected' }
  ];

  const handleCreateNew = () => {
    navigate('/admin-dashboard/create-newsletter');
  };

  const handleRegenerateSitemap = async () => {
    try {
      await downloadSitemap();
      if (onNotification) {
        onNotification({
          type: 'success',
          message: 'Sitemap regenerated and downloaded successfully!'
        });
      }
    } catch (error) {
      console.error('Error regenerating sitemap:', error);
      if (onNotification) {
        onNotification({
          type: 'error',
          message: 'Failed to regenerate sitemap. Please try again.'
        });
      }
    }
  };

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 w-full sm:w-auto">
        <Button
          variant="default"
          size="default"
          onClick={handleCreateNew}
          iconName="Plus"
          iconPosition="left"
          className="bg-accent hover:bg-accent/90 text-accent-foreground w-full sm:w-auto"
        >
          Create New Newsletter
        </Button>
        
        <Select
          options={bulkActionOptions}
          value=""
          onChange={(value) => onBulkAction(value)}
          className="w-full sm:w-48"
        />
      </div>

      <div className="flex items-center gap-3 w-full sm:w-auto">
        <Select
          options={filterOptions}
          value={currentFilter}
          onChange={onFilterChange}
          className="w-full sm:w-48"
        />
      </div>
    </div>
  );
};

export default QuickActions;